import styles from './formTitle.module.scss'

interface FormTitleProps {
	title: string
	subText?: string
}
const FormTitle = ({title, subText}: FormTitleProps) => {
	return (
		<div className={styles['form-title-wrap']}>
			<h2>{title}</h2>
			{subText && <p className={styles['form-title-subtext']}>{subText}</p>}
		</div>
	)
}

export default FormTitle
